export default "__VITE_ASSET__DlbNCTf$__"